<template>
  <div class="container">
    <div class="row">
      <div v-if="errors.length > 0" class="col-sm-12">
        <div
          v-for="(error, e) in errors"
          :key="e"
          class="alert alert-danger"
          style="display: flex; flex-flow: row; justify-content: space-between"
        >
          <span>{{ error }}</span>
          <i
            class="fa fa-times"
            style="font-size: 2rem; cursor: pointer"
            @click="dismissError(error)"
          ></i>
        </div>
      </div>
      <div
        class="col-sm-10 col-sm-offset-1"
        style="min-height: 400px; margin-bottom: 4rem"
      >
        <select-locale
          v-if="currentStep === 1"
          @next="handleNext"
        ></select-locale>
        <sales-contact-info
          v-else-if="currentStep === 2"
          @prev="handlePrev"
          @next="handleNext"
        ></sales-contact-info>
        <confirm-manufacturer-detail
          v-else-if="currentStep === 3"
          @prev="handlePrev"
          @next="handleSubmit"
        ></confirm-manufacturer-detail>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import store from "../../../store/stores";
import SelectLocale from "./components/SelectLocale.vue";
import SalesContactInfo from "./components/SalesContactInfo.vue";
import ConfirmManufacturerDetail from "./components/ConfirmManufacturerDetail.vue";

export default {
  store,
  components: {
    SelectLocale,
    SalesContactInfo,
    ConfirmManufacturerDetail,
  },
  props: {
    locales: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      currentStep: 1,
    };
  },
  computed: {
    ...mapGetters({
      errors: "manufacturer/getErrors",
    }),
  },
  mounted() {
    this.$store.commit("manufacturer/SET_LOCALES", this.locales);
  },
  methods: {
    dismissError(error) {
      this.$store.dispatch("manufacturer/DISMISS_ERROR", error);
    },
    handleNext() {
      this.currentStep += 1;
    },
    handlePrev() {
      this.currentStep -= 1;
    },
    handleSubmit() {
      this.$store.dispatch("manufacturer/SUBMIT_MANUFACTURER");
    },
  },
};
</script>
